import isOfType from '.'
import { type ILinearObject } from '../features/SurveyTempleteFeature/types'
import { red } from '../colors'
import type { ISurveyItem, ISurveySection, ISurveyTemplate } from './SurveyTemplate'

export interface SurveyChoice {
  name: string
  value: number
}

export enum SurveyQuestionType {
  Title = 'Title',
  FreeResponse = 'FreeResponse',
  LinearScale = 'LinearScale',
  MultipleChoice = 'MultipleChoice',
  DescriptiveText = 'DescriptiveText',
  MultiSelect = 'MultiSelect'
}

export interface SurveyItem {
  surveyItems: (surveyItems: any) => unknown
  itemType: SurveyQuestionType
  itemId: string
  revision: number
  prompt: string
  releaseDate?: string
}

export interface SurveyQuestion extends SurveyItem {
  itemTypeId: string
  objectId: string
  object: string[] | ILinearObject[]
}

export function isSurveyQuestion (x: any): x is SurveyQuestion {
  return isOfType<SurveyQuestion>(x, 'prompt')
}

export interface Survey {
  divisionId: string
  revision: number
  title: string
  // instanceTitle: string
  description: string
  surveyItems: SurveyQuestion[]
}

export interface SurveySubmit {
  surveyResponseItems: SurveyResponse[]
}

export type SurveyResponse = Pick<ISurveyItem, 'itemId' | 'revision'> & {
  answer: number | string | undefined
  surveySectionId?: string
  surveySectionRevision?: number
  instructorId?: string
}

export function createSurveyResponse ({ itemId, revision }: ISurveyItem, answer?: string | number, surveysection?: ISurveySection): SurveyResponse {
  return {
    answer,
    itemId,
    revision,
    surveySectionId: surveysection?.surveySectionId,
    surveySectionRevision: revision,
    ...(surveysection?.instructorId ? { instructorId: surveysection.instructorId } : {})
  }
}

export const scrollIntoView = (element: HTMLElement): void => {
  element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
}

export const showErrorAsBorderColor = (element: HTMLElement): void => { element.style.borderColor = red[700] }
export const clearErrorFromBorderColor = (element: HTMLElement): void => { element.style.borderColor = '' }
